<template>
    <ali-player v-if="loaded"  ref="player"
                :vid = 'vid'
                :playauth="playAuth"
                :encryptType = 'encryptType'
                :format="format"  ></ali-player>
  
</template>
<script>
  import AliPlayer from '@/components/AliPlayer/AliPlayer.vue';
  
  export default {
    template: '#templateId',
    name: 'tb-heading',
    components: {
      "ali-player": AliPlayer
    },
    data() {
      return {
        loaded: false,
        vid: '',
        playAuth: '',
        encryptType: 1,
        useH5Prism: true,
        playsinline: true,
        controlBarVisibility: 'hover',
        format: 'm3u8'
        
      };
    },
    methods: {
      play: function(){
        const player = this.$refs.player.instance
        player && player.play()
      },
      pause: function() {
        const player = this.$refs.player.instance
        player && player.pause()
      },
      replay: function() {
        const player = this.$refs.player.instance
        player && player.replay()
      },
      getAliUrl() {
        let params = {
          videoInfoId: 543
        };
        this.https.fetchPost('/videoInfo/getVODPlayAuth', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let playAuth = data.data.data.playAuth;
            let videoId = data.data.data.videoMeta.videoId;
            this.playAuth = playAuth;
            this.vid = videoId;
            this.loaded = true;
          } else {
            this.$message({
              type: 'info',
              message: '上传失败:' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      },
    },
    created: function() {
      this.getAliUrl();
    }
  };
</script>

<style scoped>
</style>
